/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconChevronRight from '@telus-uds/palette-koodo/build/rn/icons/ChevronRight'
import PaletteIconChevronLeft from '@telus-uds/palette-koodo/build/rn/icons/ChevronLeft'
const theme = {
  appearances: {
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'xs' ] },
      tokens: {
        calendarMonthCaptionFontName: 'StagSans',
        calendarMonthCaptionFontSize: 14,
        calendarMonthCaptionFontWeight: '600',
        calendarMonthCaptionLineHeight: 1.72
      }
    }
  ],
  tokens: {
    calendarBackgroundColor: '#ffffff',
    calendarDayBlockedCalendarHoverBackground: '#efefef',
    calendarDayBlockedCalendarHoverColor: '#666666',
    calendarDayDefaultBackgroundColor: '#ffffff',
    calendarDayDefaultBorder: 1,
    calendarDayDefaultBorderColor: '#c9c8c8',
    calendarDayDefaultCalendarDaySelectedHoverBackground: '#ffffff',
    calendarDayDefaultCalendarDaySelectedHoverBeforeBackground: '#7a3dfc',
    calendarDayDefaultCalendarDaySelectedHoverColor: '#ffffff',
    calendarDayDefaultColor: '#000000',
    calendarDayDefaultFontName: 'StagSans',
    calendarDayDefaultFontSize: 14,
    calendarDayDefaultFontWeight: '400',
    calendarDaySelectedDisabledBackground: '#efefef',
    calendarDaySelectedDisabledColor: '#ffffff',
    calendarDaySelectedDisabledContentBackgroundColor: '#c9c8c8',
    calendarDaySelectedFocusBeforeBackground: '#ffffff',
    calendarDaySelectedHoverBackground: '#ffffff',
    calendarDaySelectedHoverBeforeBackground: '#ffffff',
    calendarDaySelectedHoverBeforeBorderColor: '#7a3dfc',
    calendarDaySelectedHoverBorderColor: '#c9c8c8',
    calendarDaySelectedHoverColor: '#000000',
    calendarMonthCaptionColor: '#000000',
    calendarMonthCaptionFontName: 'StagSans',
    calendarMonthCaptionFontSize: 20,
    calendarMonthCaptionFontWeight: '700',
    calendarMonthCaptionLineHeight: 1.2,
    calendarMonthCaptionPaddingBottom: 48,
    dateInputStrokeColor: '#666666',
    dayPickerNavigationButtonPadding: 12,
    dayPickerWeekHeaderColor: '#000000',
    dayPickerWeekHeaderFontName: 'StagSans',
    dayPickerWeekHeaderFontWeight: '700',
    dayPickerWeekHeaderLineHeight: 1.14285714286,
    dayPickerWeekHeaderSmall: 14,
    hiddenInputFieldContainerHeight: 0,
    hiddenInputFieldContainerWidth: 0,
    invalidInputMixin: null,
    nextIcon: PaletteIconChevronRight,
    previousIcon: PaletteIconChevronLeft,
    singleDatePickerBorderColor: '#666666',
    singleDatePickerLeftRight: 16,
    singleDatePickerPaddingTopBottom: 8,
    singleDatePickerRadius: 4,
    validInputMixin: null
  }
}
export default theme
